Pixlee.module('Entities', function (Entities, App, Backbone, Marionette, $) {
    var Product = Entities.Model.extend({
        defaults: {
            _ENTITY_NAME: 'Product'
        }
    });
    Entities.Product = Product;

    /**
     * A collection of products. These products are "search aware",
     * meaning that any changes to the searchModel on this collection will
     * refetch this collection.
     */
    var Products = Entities.PaginatedCollection.extend({
        model: Entities.Product,
        url: function () {
            var search_term = encodeURIComponent(this.searchModel.get('search_term'));
            return Routes.distillery_products_path() + '&search_term=' + search_term;
        },
        parse: function(res) {
            return res.data;
        },
        server_api: {
            page: function () {
                return this.page;
            },
            per_page: function () {
                return this.per_page;
            },
            category_album_id: function() {
                return this.category_album_id;
            }
        },
        initialize: function (_models, opts) {
            this.searchModel = new SearchModel();
            this.category_album_id = opts.category_album_id;

            var searchModelChanged = function() {
                if (opts.category_album_id) {
                    return this.fetch();
                }
                if (this.searchModel.get('search_term') === '') {
                    this.reset();
                } else {
                    // fetch basically does a reset once it's done, but calling reset early lets
                    // us trigger a reset event so we can show a loading view while it is
                    // fetching.
                    this.reset();
                    this.fetch();
                }
            }.bind(this);
            this.searchModelChanged = _.debounce(searchModelChanged, 500);
            this.listenTo(this.searchModel, 'change', this.searchModelChanged);

            this.loading = false;
            this.listenTo(this, {
                'request': function() { this.loading = true; },
                'sync error': function() { this.loading = false; }
            });

            this.paginator_core.url = this.url;
        }
    })
    Entities.Products = Products;

    var SearchModel = Entities.Model.extend({
        defaults: {
            _ENTITY_NAME: 'SearchModel',
            search_term: ''
        }
    });

    var Tag = Entities.Model.extend({
        defaults: {
            _ENTITY_NAME: 'Tag'
        }
    });
    Entities.Tag = Tag;

    /**
     * A collection of tags. These tags are "search aware",
     * meaning that any changes to the searchModel on this collection will
     * refetch this collection.
     */
    var Tags = Entities.PaginatedCollection.extend({
        model: Entities.Tag,
        url: function () {
            var search_term = encodeURIComponent(this.searchModel.get('search_term'));
            return Routes.distillery_tag_albums_path() + '&search_term=' + search_term;
        },
        parse: function(res) {
            return res.data;
        },
        server_api: {
            page: function () {
                return this.page;
            },
            per_page: function () {
                return this.per_page;
            }
        },
        initialize: function () {
            this.searchModel = new SearchModel();

            var searchModelChanged = function() {
                if (this.searchModel.get('search_term') === '') {
                    this.reset();
                } else {
                    this.reset();
                    this.fetch();
                }
            }.bind(this);
            this.searchModelChanged = _.debounce(searchModelChanged, 500);
            this.listenTo(this.searchModel, 'change', this.searchModelChanged);

            this.loading = false;
            this.listenTo(this, {
                'request': function() { this.loading = true; },
                'sync error': function() { this.loading = false; }
            });

            this.paginator_core.url = this.url;
        }
    })
    Entities.Tags = Tags;
});
